import React, { useState } from "react";

import defaultTheme from "./theme-test-override";
import styled from "styled-components";
import { remCalc } from "./style-utils-coras-nua";
import { space, typography, color } from "styled-system";
import { Flexbox } from "./grid";

const StyledPanel = styled.div`
    ${color}
    ${space}
    ${typography}

    &.accordion-panel{
        width: 73%;
        padding: 20px 16px;
        border-radius: 5px;
        box-sizing: border-box;
        .accordion-label{
            display: flex;
            align-items: center;
            cursor: pointer;
            font-weight: 900;
            &>*:first-child{
                order: 1;
            }
            &::after{
                content: '';
                order: 2;
                position: relative;
                margin-left: auto;
                color: ${props => props.theme.colors.primary};
                width: ${remCalc(14)};
                height: ${remCalc(22)};
                background-repeat: no-repeat;
                background-position: center center;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill-rule='evenodd' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill='none' d='M-826-1513H454v6951H-826z'/%3E%3Cpath d='M3.825 7.585a.5.5 0 0 1 .547.131l7.63 8.58 7.63-8.58a.5.5 0 0 1 .894.146.5.5 0 0 1-.154.514l-8 9a.49.49 0 0 1-.74 0l-8-9a.46.46 0 0 1-.13-.33.5.5 0 0 1 .323-.461z' fill='%23161616' fill-rule='nonzero'/%3E%3C/svg%3E");
            }
        }
        .accordion-content{
            display: none;
            padding-top: ${remCalc(20)};

            .formContent{
                background-color: unset;

                & > div {
                    padding: 0;

                    & > form > div {
                        padding: 0;
                    }
                }
            }
        }
        &.open{
            .accordion-label{
                &::after{
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill-rule='evenodd' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill='none' d='M-826-1471H454v6951H-826z'/%3E%3Cpath d='M20.5 16.954a.5.5 0 0 1-.868.328l-7.611-8.54-7.611 8.54a.5.5 0 0 1-.892-.145c-.053-.186.007-.386.154-.512l7.98-8.958a.49.49 0 0 1 .738 0l7.98 8.958a.46.46 0 0 1 .13.328h0z' fill='%23161616' fill-rule='nonzero'/%3E%3C/svg%3E");
                }
            }
            .accordion-content{
                display: block;
            }
        }
    }
`;

StyledPanel.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

const AccordionPanel = ({
    label,
    children,
    className = "",
    ...props
}) => {
    const [isOpen, setIsOpen] = useState(props.isOpen || false);
    return (
            <StyledPanel
                className={
                    "accordion-panel"
                        + (isOpen ? " open" : "")
                        + (className ? " " + className : "")
                }
                {...props}
            >
                <div
                    className="accordion-label"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {label || "Accordion Panel"}
                </div>
                <div className="accordion-content">
                    {children}
                </div>
            </StyledPanel>
    );
}

const Accordion = ({
    children,
    flexDirection = "column",
    alignItems = "center",
    className = ""
}) => {
    return (
        <Flexbox
            className={`${className} accordion`}
            display={"flex"}
            flexDirection={flexDirection}
            alignItems={alignItems}
        >
            {children}
        </Flexbox>
    )
}

export default Accordion;
export { AccordionPanel };
